exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.filter-container[data-v-30b27957] {\n  padding-bottom: 10px;\n}\n.filter-item[data-v-30b27957] {\n  margin-right: 10px;\n}\n", ""]);

// exports
